<template>
  <div class="study-plans pb-5 position-relative">
    <transition name="slide" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import { app } from '../index'

export default {
  name: 'StudyPlans',
  watch: {
    $route (to) {
      if (to.name === 'study_plans_list_path') {
        this.setHeader()
      }
    },
  },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.header.study_plan.title'),
      })
    },
  },
  beforeRouteEnter (to, from, next) {
    const role = localStorage.getItem('prkCR')
    if (['admin', 'employer'].includes(role)) {
      next(vm => {
        vm.setHeader()
      })
    } else {
      app.$toastr.e(app.$t('general.forbidden'))
    }
  },
}
</script>
